<template>
  <ContentWrap>
    <el-alert
      class="mb-16px"
      type="info"
      :closable="false"
      title="配置商城搜索页「搜索热词」：输入关键词后点「添加」，会显示为标签；点标签上的 × 可删除。用户点选后进入商品列表搜索；未配置则 C 端不展示。最多 20 个，每个最多 20 字；先添加的排在前面。"
    />
    <el-form v-loading="formLoading" label-width="120px" @submit.prevent>
      <el-form-item label="搜索热词">
        <div class="hot-box">
          <div v-if="hotKeywords.length" class="hot-box__tags">
            <el-tag
              v-for="(kw, index) in hotKeywords"
              :key="kw + '-' + index"
              class="hot-box__tag"
              closable
              size="large"
              @close="removeKeyword(index)"
            >
              {{ kw }}
            </el-tag>
          </div>
          <div v-else class="hot-box__empty">暂无热词，请在下方输入后添加</div>
          <div class="hot-box__input">
            <el-input
              v-model="draft"
              class="!w-320px"
              maxlength="20"
              show-word-limit
              clearable
              placeholder="输入热词，点添加"
              :disabled="hotKeywords.length >= 20"
              @keydown.enter.prevent
            />
            <el-button
              type="primary"
              :disabled="!draft.trim() || hotKeywords.length >= 20"
              @click="addKeyword"
            >
              添加
            </el-button>
            <el-text size="small" type="info">已添加 {{ hotKeywords.length }} / 20</el-text>
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button
          v-hasPermi="['trade:mall-search-config:save']"
          :loading="formLoading"
          type="primary"
          @click="submitForm"
        >
          保 存
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>
</template>

<script lang="ts" setup>
import * as MallSearchConfigApi from '@/api/mall/trade/mallSearchConfig'

defineOptions({ name: 'TradeMallSearchConfig' })

const message = useMessage()
const formLoading = ref(false)
const hotKeywords = ref<string[]>([])
const draft = ref('')

const addKeyword = () => {
  const kw = draft.value.trim()
  if (!kw) {
    return
  }
  if (kw.length > 20) {
    message.warning('单个热词最多 20 字')
    return
  }
  if (hotKeywords.value.length >= 20) {
    message.warning('最多 20 个热词')
    return
  }
  if (hotKeywords.value.includes(kw)) {
    message.warning('该热词已存在')
    return
  }
  hotKeywords.value.push(kw)
  draft.value = ''
}

const removeKeyword = (index: number) => {
  hotKeywords.value.splice(index, 1)
}

const getForm = async () => {
  formLoading.value = true
  try {
    const data = await MallSearchConfigApi.getMallSearchConfig()
    hotKeywords.value = Array.isArray(data?.hotKeywords) ? [...data.hotKeywords] : []
  } finally {
    formLoading.value = false
  }
}

const submitForm = async () => {
  formLoading.value = true
  try {
    await MallSearchConfigApi.saveMallSearchConfig({ hotKeywords: [...hotKeywords.value] })
    message.success('保存成功')
    await getForm()
  } finally {
    formLoading.value = false
  }
}

onMounted(() => {
  getForm()
})
</script>

<style scoped>
.hot-box {
  width: 100%;
  max-width: 720px;
}
.hot-box__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 12px;
}
.hot-box__tag {
  margin: 0;
}
.hot-box__empty {
  margin-bottom: 12px;
  color: #909399;
  font-size: 13px;
}
.hot-box__input {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}
</style>
